import { Button, InventoryType, ReportItem } from '@vessel-reports/noon/state/noon.types';

export const buttons: Button[] = [
  {
    id: 1,
    active: false,
    title: 'ARRIVAL',
    value: 6
  },
  {
    id: 2,
    active: false,
    title: 'DEPARTURE',
    value: 8
  }
];

export const inventories: InventoryType[] = [
  {
    id: 1,
    title: 'HFO',
    value: 1
  },
  {
    id: 2,
    title: 'MGO',
    value: 2
  },
  {
    id: 3,
    title: 'Main Engine - Cylinder Oil',
    value: 3
  },
  {
    id: 4,
    title: 'Main Engine - System Oil',
    value: 4
  },
  {
    id: 5,
    title: 'Generator Engine - System Oil',
    value: 5
  },
  {
    id: 6,
    title: 'Fresh Water',
    value: 37
  }
];

export const ArrivalSteps = [
  { id: 1, step: 1, active: false, title: 'Port Info' },
  { id: 2, step: 2, active: false, title: 'Arrival ROB & Draft' },
  { id: 3, step: 3, active: false, title: 'Consumption' }
];

export const DepatureSteps = [
  { id: 1, step: 1, active: false, title: 'Port Info' },
  { id: 2, step: 2, active: false, title: 'Departure ROB & Draft' },
  { id: 3, step: 3, active: false, title: 'Consumption' }
];

export const VesselTypes: Button[] = [
  { id: 1, title: 'BALLAST', active: false, value: 0 },
  { id: 2, title: 'LADEN', active: false, value: 1 }
];

export const PortInformationArrival: ReportItem[] = [
  {
    id: null,
    report_item_id: 38,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 9,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 43,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 40,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 41,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 42,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 10,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 11,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 12,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 2,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 44,
    description: null,
    value: null,
    remarks: null
  }
];

export const PortInformationDeparture: ReportItem[] = [
  {
    id: null,
    report_item_id: 38,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 9,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 46,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 45,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 47,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 48,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 10,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 11,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 12,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 1,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 49,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 6,
    description: null,
    value: null,
    remarks: null
  }
];

export const Consumptions: ReportItem[] = [
  {
    id: null,
    report_item_id: 20,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 21,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 22,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 23,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 24,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 25,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 26,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 27,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 28,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 29,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 30,
    description: null,
    value: null,
    remarks: null
  }
];

export enum REPORT_TYPE {
  ARRIVAL = 6,
  DEPARTURE = 8
}

export enum REPORT_STATUS {
  DRAFT = 1,
  SAVED,
  SUBMITTED
}
